import React, { useEffect, useRef, useState } from 'react';
import { MdMiscellaneousServices } from "react-icons/md";
import "./SelectionLayoutPitch.css";
import { AiFillFormatPainter } from "react-icons/ai";
import { IoSettings } from "react-icons/io5";
import { MdAdminPanelSettings, MdOutlineDisplaySettings } from "react-icons/md";
import { TbRosetteDiscountCheckFilled } from "react-icons/tb";
import useApiFetcher from '../../../../hooks/useApiFetcher';
import GaugeMeter from '../../../DealerShipDashBoard/GaugeMeter';
import GaugeMeter2 from '../../../DealerShipDashBoard/GaugeMeter2';



// const labels = ['Service Contract', 'Maintenance Upgrade', 'Platinum Service', 'Gap Insurance'];
const SelectionLayout = ({ statusArr,isSpeaking, isListening, isThinking, apiData, coreFeature, partialFeature, index, priceArr, setIndex, labels = [], status = [], setStatus, speakSelectedText, unSelectionScript, reSelectionScript, scriptArr, isSpeakingEnabled, totalPrice, tempArr, monthlyPayment, userQueriesHistory }) => {
  const { apiFetcher } = useApiFetcher()
  const [isButtonClicked, setIsButtonClicked] = useState(false);

  console.log("coreFeature", coreFeature)
  const handleChange = async (index) => {
    const newStatus = !status[index];
  if (status[index] === newStatus) return;
    // Update the status array
    const updatedStatus = status.map((status, i) => (i === index ? !status : status));
    setStatus(updatedStatus);
    const newTempArr = updatedStatus.map((status, i) => (status ? priceArr[i] : 0));
    console.log(newTempArr, 'newtempar')
    const newTotalPrice = newTempArr.reduce((sum, price) => sum + price, 0);
  
    isSpeakingEnabled = false;
    if (status[index] !== updatedStatus[index]) {
      if (updatedStatus[index]) {
        speakSelectedText(`Great choice! That’s a fantastic addition ${labels[index]} to your cart! I’m sure you’ll really enjoy it. Right now, your total amount is ${newTotalPrice} dollars. If you’d like to add or change anything, feel free to let me know. I’m happy to assist you further!`);
      } else {
        speakSelectedText(`Oh, I see you’ve decided to remove ${labels[index]}. No worries, I totally understand—it’s all about finding what works best for you! If you change your mind or need more information on any other options, feel free to ask. As of now, your total amount is ${newTotalPrice} dollar. Let me know if you'd like to make any other adjustments or if you need assistance with anything else!`);  
      }
    }
  };


  const icons = [
    <IoSettings />,
    <MdAdminPanelSettings />,
    <TbRosetteDiscountCheckFilled />,
    <MdOutlineDisplaySettings />,
    <AiFillFormatPainter />,
  ];
  // const prevHistoryLength = useRef(userQueriesHistory.length);

  // useEffect(() => {
  //   prevHistoryLength.current = userQueriesHistory.length; // Keep ref updated
  // }, [userQueriesHistory]);

  const handleNext = async () => {
    if (!isButtonClicked) {
      setIsButtonClicked(true); // Disable the button after clicking
      setIndex((prev) => prev + 1); // Increment the index
      StopTime()
    }
  };
  const StopTime = () => {
    setTimeout(() => {
      setIsButtonClicked(false);
      console.log("Start Button")
    }, 4000)
  }
  return (
    <div className="app-containers">
      <div className="options-containers animate-left-to-right">

        {labels && labels.map((label, index) => (
          <div key={index}>
            <div

              className={`option-polygons ${index + 1} ${status[index] ? 'selecteds' : ''}`}
            >
              <span className="textNames">{label}</span>

              <div className="textContainers">
                <div className="iconImgs">
                  {icons[index] || <MdMiscellaneousServices />}

                </div>

                {isSpeaking && !isListening && !isThinking &&
                  <input
                    type="checkbox"
                    checked={status[index]}
                    readOnly
                    onChange={() => handleChange(index)}
                    className="checkboxs"
                  />}

              </div>

            </div>
            <div className="feature-labels">
              {status[index] ? coreFeature[index] : null}
            </div>
            <div className='priceCons'><b>${tempArr[index]} </b></div>
          </div>
        ))}
      </div>
      {/* <div className='priceCon'>

      {tempArr.map((price, index) => (
      <div key={index} className="price-item">
        <h6>${price}</h6>
      </div>
    ))}
    </div> */}

      <div className="price-containers">
        <p className="total-prices"><b>Bundle Total:</b> ${totalPrice} </p>
      </div>

      {
        isSpeaking && !isListening && !isThinking ? (
          <button className='buttonLoans' onClick={() => handleNext(userQueriesHistory)}>{`Proceed to ${status.every((status) => status)
            ? "Checkout"
            : "Partial Bundle"
            } `}</button>
        ) :
          (<button className='buttonLoandisables' >
            Proceed to Partial Bundle
          </button>
          )
      }

      {/* Risk indicator */}
      {/* <RiskIndicator status={status} /> */}
      {/* <div className='meterContainer'>
      <GaugeMeter status={status}/>
      <GaugeMeter2 status={status}/>
      </div> */}

    </div>
  );
};

export default SelectionLayout;
